import { fbDB } from "../config/firebase";
import {
  FINAL_VOTING_WATCH_ON,
  FINAL_VOTING_WATCH_OFF,
  FINAL_VOTING_TARGET_UPDATE
} from "./types";

export const finalVotingWatchOn = () => async dispatch => {
  fbDB.ref("/finalVoting").on("value", snapshot =>
    dispatch({
      type: FINAL_VOTING_WATCH_ON,
      payload: snapshot.val()
    })
  );
};

export const finalVotingWatchOff = () => async dispatch => {
  fbDB.ref("/finalVoting").off();
  return dispatch({
    type: FINAL_VOTING_WATCH_OFF,
    payload: null
  });
};

export const finalVotingTargetToggle = (cCode, uid) => async dispatch => {
  fbDB.ref(`/finalVoting/${cCode}/absent`).transaction(data => {
    if (data === null) {
      return [uid];
    } else if (data.filter(v => v === uid).length) {
      return data.filter(v => v !== uid);
    } else if (!data.filter(v => v === uid).length) {
      return [...data, uid];
    }
  });
};
